import axios from "axios";
import { BASE_API } from "../../config/api";

export const getJobLogsAsync = async (jobId) =>
  await axios
    .get(`${BASE_API}job-log/logs/${jobId}`)
    .then((response) => response && response.data)
    .catch((error) => error.message);